import { render, staticRenderFns } from "./PersonnelKpiV3.vue?vue&type=template&id=0ddf4288&scoped=true"
import script from "./PersonnelKpiV3.vue?vue&type=script&lang=js"
export * from "./PersonnelKpiV3.vue?vue&type=script&lang=js"
import style0 from "./PersonnelKpiV3.vue?vue&type=style&index=0&id=0ddf4288&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf4288",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ddf4288')) {
      api.createRecord('0ddf4288', component.options)
    } else {
      api.reload('0ddf4288', component.options)
    }
    module.hot.accept("./PersonnelKpiV3.vue?vue&type=template&id=0ddf4288&scoped=true", function () {
      api.rerender('0ddf4288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/v3/PersonnelKpiV3.vue"
export default component.exports